import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useLayoutEffect,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./EmailTemplate.module.css";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";
import Button from "@mui/material/Button";
import { templateActions } from "@_actions/template.actions";
import { catchError, newLinesToPTag } from "@_utils/helpers";
import { emailActions } from "@_actions/email_flows.actions";
import { isNull } from "@_utils/helpers";
import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";
import Tooltip from "@mui/material/Tooltip";
import AreYouSurePopup from "@_components/popups/AreYouSurePopup/AreYouSurePopup";
import { emailConstants } from "@_constants/email_flows.constants";
import { caseConstants } from "@_constants/case.constants";
import ChangeEmailTemplatePopup from "@_components/popups/ChangeEmailTemplatePopup/ChangeEmailTemplatePopup";
import InfoPopup from "@_components/popups/InfoPopup/InfoPopup";
import SalutationsPlaceholderPopup from "@_components/popups/SalutationsPlaceholderPopup/SalutationsPlaceholderPopup";
import SettlementPortalLinkPopup from "@_components/popups/SettlementPortalLinkPopup/SettlementPortalLinkPopup";

import ImageUsesPlaceholderPopup from "@_components/popups/ImageUsesPlaceholderPopup/ImageUsesPlaceholderPopup";
import $ from "jquery";
import "../../@_utils/highlightTextArea/jquery.highlighttextarea";
import Scrollbar from "react-perfect-scrollbar-z";
import "scrollbar.css";
import { InfoOutlined } from "@mui/icons-material";
import { IconButton, MenuItem } from "@mui/material";
import { IsoRegionLanguageList } from "@_configs/LanguageList.config";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function EmailTemplate({ onClickOutside, data }) {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const editor = useRef(null);
  const history = useHistory();

  const emailFlowReducer = useSelector((state) => state.emailFlowReducer);

  const templateReducer = useSelector((state) => state.templateReducer);
  const selectedTemplate = templateReducer.selected_template;
  const [templateDetails, setTemplateDetails] = useState({
    name: (selectedTemplate && selectedTemplate.name) || "",
    subject: (selectedTemplate && selectedTemplate.subject) || "",
    content: (selectedTemplate && selectedTemplate.content) || "",
    schedule_num_days:
      (selectedTemplate && selectedTemplate.schedule_num_days) || "",
    type: (selectedTemplate && selectedTemplate.type) || "",
    trigger_event:
      (selectedTemplate && selectedTemplate.trigger_event) || undefined,
    config: (selectedTemplate && selectedTemplate.config) || {},
    localization:
      (selectedTemplate && selectedTemplate.localization) || "en-GB",
  });

  const [node, setNode] = useState(null);

  const measuredRef = useCallback((node) => {
    if (node !== null) {
      setNode(node);
    }
  }, []);

  // layout effect for setting height on resize event of the refenced node
  useLayoutEffect(() => {
    if (node) {
      const measure = () => {
        if (editor.current && editor.current.setOptions)
          editor.current.setOptions({
            ...editor.current.getContext().options,
            height:
              (
                document.getElementById("placeholder_container_id")
                  .clientHeight - 95
              ).toString() + "px",
          });
      };

      window.addEventListener("resize", measure);

      return () => {
        window.removeEventListener("resize", measure);
      };
    }
  }, [node]);

  useEffect(() => {
    if (selectedTemplate && selectedTemplate.content)
      setContent(selectedTemplate.content);
    // update editor
    if (editor.current) {
      // set initial heigth. We have to use a timout here because our refernce div will sized only after some time
      setTimeout(() => {
        // use setOptions to update height
        editor.current.setOptions({
          ...editor.current.getContext().options,
          height:
            // get infor container height and calculate the new height
            (
              document.getElementById("placeholder_container_id").clientHeight -
              95
            ).toString() + "px",
        });
      }, 500);

      editor.current.setContents("");
      if (
        selectedTemplate &&
        selectedTemplate.content &&
        selectedTemplate.content.length > 0
      ) {
        editor.current.insertHtmlNoNewLine(
          newLinesToPTag(selectedTemplate.content),
          true,
        );
      }
    }
  }, [selectedTemplate]);

  const [curPosition, setCurPosition] = useState();
  /**
   * Holds HTML of editor
   */
  const [content, setContent] = useState(
    (selectedTemplate && selectedTemplate.content) || "",
  );
  const { snackbarProps, showSnackbarSuccess, showSnackbarError } =
    useSnackbar();
  const [btnPressed, setBtnPressed] = useState(false);
  const [subjectClicked, setSubjectClicked] = useState(false);
  const [contentClicked, setContentClicked] = useState(false);
  const [disabledPlaceholders, setDisabledPlaceholders] = useState(true);
  const [openAreYouSurePopup, setOpenAreYouSurePopup] = useState(false);
  const [openChangeEmailTemplatePopup, setOpenChangeEmailTemplatePopup] =
    useState(false);
  const [deleteOrSubmit, setDeleteOrSubmit] = useState(null);
  const [currentEmaiFlow, setCurrentEmailFlow] = useState({});
  const [openInfoPopup, setOpenInfoPopup] = useState(false);
  const [openImageUsesPopup, setOpenImageUsesPopup] = useState(false);
  const [oldImageUseOptions, setOldImageUseOptions] = useState(null);
  const [openSalutationsPopup, setOpenSalutationsPopup] = useState(false);
  const [oldSalutationsOptions, setOldSalutationsOptions] = useState(null);
  const [openSettlementPortalPopup, setOpenSettlementPortalPopup] =
    useState(false);
  const [oldSettlementPortalOptions, setOldSettlementPortalOptions] =
    useState(null);

  const [wordClicked, setWordClicked] = useState(null);
  const [lastLocalization, setLastLocalization] = useState("");

  const temlateContainerRef = useRef(null);

  useEffect(() => {
    if (
      selectedTemplate &&
      selectedTemplate.emailFlowId &&
      emailFlowReducer.emailFlows
    )
      setCurrentEmailFlow(
        emailFlowReducer.emailFlows.find(
          (email) => email.id === selectedTemplate.emailFlowId,
        ),
      );
  }, [emailFlowReducer, selectedTemplate]);

  useEffect(() => {
    const handleResize = () => {
      if (temlateContainerRef.current) {
      }
    };
    // Initial resize
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [temlateContainerRef]);

  useEffect(() => {
    dispatch(templateActions.getPlaceholders());
  }, [dispatch]);

  useEffect(() => {
    setBtnPressed(false);
    setContent((selectedTemplate && selectedTemplate.content) || "");
    const flowTemplates =
      templateReducer.flow_templates[selectedTemplate.emailFlowId];
    let lastLocalization = "en-GB";
    if (selectedTemplate?.localization) {
      lastLocalization = selectedTemplate.localization;
    } else if (flowTemplates && flowTemplates.length > 0) {
      const sortedTemplates = flowTemplates.sort(
        (a, b) => new Date(b.updated) - new Date(a.updated),
      );
      const lastTemplate = sortedTemplates.find(
        (template) => template.localization,
      );
      lastLocalization = lastTemplate ? lastTemplate.localization : "en-GB";
    }
    setLastLocalization(lastLocalization);

    setTemplateDetails({
      name: (selectedTemplate && selectedTemplate.name) || "",
      subject: (selectedTemplate && selectedTemplate.subject) || "",
      content: (selectedTemplate && selectedTemplate.content) || "",
      schedule_num_days:
        (selectedTemplate && selectedTemplate.schedule_num_days) || "",
      type: (selectedTemplate && selectedTemplate.type) || "",
      trigger_event:
        (selectedTemplate && selectedTemplate.trigger_event) || undefined,
      config: (selectedTemplate && selectedTemplate.config) || {},
      localization: lastLocalization,
    });
    setWordClicked(null);
    setOldImageUseOptions(null);
    setOldSalutationsOptions(null);
    setOldSettlementPortalOptions(null);

    $("textarea.text-highlight-target").highlightTextarea("destroy");
    // eslint-disable-next-line
  }, [selectedTemplate]);

  useEffect(() => {
    if (
      !templateDetails.localization ||
      templateDetails.localization === "en-GB"
    ) {
      setTemplateDetails((prevDetails) => ({
        ...prevDetails,
        localization: lastLocalization,
      }));
    }
    // eslint-disable-next-line
  }, [lastLocalization]);

  const handleSaveCursorPosition = (e) => {
    setCurPosition(e.target.selectionStart);
    setSubjectClicked(false);
    setDisabledPlaceholders(false);
    setContentClicked(true);
  };

  const syncTextAreaHighlighterWidth = useCallback(() => {
    const $textAreaTarget = $("textarea.text-highlight-target");
    if (!$textAreaTarget.length) return;

    const fieldWidth = $textAreaTarget.closest(".MuiFormControl-root").width();
    if (!fieldWidth) return;

    const pixelWidth = `${fieldWidth - 20}px`;
    $textAreaTarget.css({ width: pixelWidth, maxWidth: pixelWidth });

    const $highlightWrapper = $textAreaTarget.closest(".highlightTextarea");
    $highlightWrapper.css({ width: pixelWidth, maxWidth: pixelWidth });
    $highlightWrapper
      .find(".highlightTextarea-container, .highlightTextarea-highlighter")
      .css({ width: pixelWidth, maxWidth: pixelWidth });

    const highlighter = $textAreaTarget.data("highlighter");
    if (highlighter && typeof highlighter.updateSizePosition === "function") {
      highlighter.updateSizePosition(true);
    }
  }, []);

  useEffect(() => {
    setTemplateDetails({ ...templateDetails, content: content });

    let wordsArray = [
      "{{image_uses}}",
      "{{salutation}}",
      "{{settlement_portal}}",
    ];
    for (let i = 0; i < 10; i++) {
      wordsArray.push("{{image_uses_" + i + "}}");
      wordsArray.push("{{salutation_" + i + "}}");
      wordsArray.push("{{settlement_portal_" + i + "}}");
    }

    const $textAreaTarget = $("textarea.text-highlight-target");

    $textAreaTarget.highlightTextarea({
      words: wordsArray,
      color: "#b3b3b3",
    });

    const frameId = window.requestAnimationFrame(() => {
      syncTextAreaHighlighterWidth();
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  useEffect(() => {
    const onResize = () => {
      syncTextAreaHighlighterWidth();
    };

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [syncTextAreaHighlighterWidth]);

  // useEffect(() => {
  //   $("textarea").highlightTextarea("destroy");
  // }, [selectedTemplate]);

  const handleSubjectPlaceholder = (e) => {
    setCurPosition(e.target.selectionStart);
    setSubjectClicked(true);
    setDisabledPlaceholders(false);
    setContentClicked(false);
  };

  const handleInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    setCurPosition(e.target.selectionStart);
    if (name === "schedule_num_days" && value) {
      value = parseInt(value);
    }
    if (name === "sender_address") {
      const lineCount = value.split("\n").length;

      if (lineCount > 5) {
        return;
      }
    }
    if (
      name === "case_pin_label" ||
      name === "case_id_label" ||
      name === "sender_address"
    ) {
      setTemplateDetails((templateDetails) => ({
        ...templateDetails,
        config: {
          ...templateDetails.config,
          letter_header: {
            ...templateDetails.config.letter_header,
            [name]: value,
          },
        },
      }));
    } else {
      setTemplateDetails((templateDetails) => ({
        ...templateDetails,
        [name]: value,
      }));
    }
  };
  const handleDeleteTemplate = () => {
    setDeleteOrSubmit(0);
    selectedTemplate.scheduled_emails &&
    selectedTemplate.scheduled_emails.some(
      (email) => email.status !== caseConstants.CASE_ACTIVITY_STATE_SENT,
    )
      ? setOpenChangeEmailTemplatePopup(true)
      : setOpenAreYouSurePopup(true);
  };

  const deleteTemplate = (updateScheduledEmails) => {
    dispatch(
      templateActions.deleteTemplate(
        emailFlowReducer.selected_email || selectedTemplate.emailFlowId,
        selectedTemplate.id,
        updateScheduledEmails,
      ),
    );
    setDeleteOrSubmit(null);
    setOpenChangeEmailTemplatePopup(false);
  };

  const checkScheduledDays = (num) => {
    if (
      templateReducer.flow_templates &&
      templateReducer.flow_templates[emailFlowReducer.selected_email]?.length >
        0
    ) {
      let template = templateReducer.flow_templates[
        emailFlowReducer.selected_email
      ].find(
        (x) =>
          selectedTemplate &&
          x &&
          x.type === emailConstants.TEMPLATE_TYPE_SCHEDULED &&
          x.name !== selectedTemplate.name &&
          x.schedule_num_days === num,
      );
      return template;
    }
    return false;
  };

  const validateInputs = () => {
    if (isNull(templateDetails.name)) {
      showSnackbarError("Please enter a name for your template.");
      return false;
    } else if (isNull(templateDetails.localization)) {
      showSnackbarError("Please select a localization for your template.");
      return false;
    } else if (isNull(templateDetails.subject)) {
      showSnackbarError("Please enter a subject for your template.");
      return false;
    } else if (isNull(templateDetails.content)) {
      showSnackbarError("Please enter content for your template.");
      return false;
    } else if (
      isNull(templateDetails.schedule_num_days) &&
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_SCHEDULED
    ) {
      showSnackbarError("Please enter Number of Days for your template.");
      return false;
    } else if (
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_LETTER &&
      (!templateDetails.config?.letter_header ||
        isNull(templateDetails.config.letter_header?.case_pin_label))
    ) {
      showSnackbarError("Please enter Case PIN Label for your template.");
      return false;
    } else if (
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_LETTER &&
      (!templateDetails.config.letter_header ||
        isNull(templateDetails.config.letter_header?.case_id_label))
    ) {
      showSnackbarError("Please enter Case ID Label for your template.");
      return false;
    }
    return true;
  };

  const handleScheduleNumDays = () => {
    if (
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_TRIGGERED ||
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_CUSTOM ||
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_LETTER
    ) {
      delete templateDetails.schedule_num_days;
    } else if (
      selectedTemplate.type === emailConstants.TEMPLATE_TYPE_SCHEDULED &&
      !selectedTemplate.trigger_event
    ) {
      const templateWithSameDays = checkScheduledDays(
        templateDetails.schedule_num_days,
      );
      if (templateWithSameDays) {
        showSnackbarError(
          `Another email is scheduled to be sent after ${templateDetails.schedule_num_days} day(s), please choose another period.`,
        );
        return false;
      }
    }
    return true;
  };

  const handleSubmitTemplateDetails = (updateScheduledEmails) => {
    setBtnPressed(true);

    if (!handleScheduleNumDays()) return;

    if (!validateInputs()) return;

    templateDetails["emailFlowId"] = emailFlowReducer.selected_email;

    // Checks if we are updating an existing template or creating a new one
    if (selectedTemplate && selectedTemplate.id) {
      // Checks if the template is a scheduled mail and if it is attached to a case and not sent
      if (
        selectedTemplate.scheduled_emails &&
        selectedTemplate.scheduled_emails.some(
          (email) => email.status !== caseConstants.CASE_ACTIVITY_STATE_SENT,
        ) &&
        !(typeof updateScheduledEmails === "boolean")
      ) {
        setDeleteOrSubmit(1);
        setOpenChangeEmailTemplatePopup(true);
      } else {
        const cleanconfig = (prevConfig) => {
          if (prevConfig?.placeholder) {
            Object.keys(prevConfig.placeholders).forEach((placeholder) => {
              if (
                templateDetails.content.indexOf(`{{${placeholder}}}`) === -1
              ) {
                delete prevConfig.placeholders[placeholder];
              }
            });
            return prevConfig.placeholders;
          } else return;
        };

        setTemplateDetails((prevTemplateDetails) => {
          let updatedSetting;
          if (prevTemplateDetails) {
            updatedSetting = cleanconfig(prevTemplateDetails.config);
          }
          dispatchTemplateUpdate(updateScheduledEmails);
          return {
            ...prevTemplateDetails,
            config: {
              ...prevTemplateDetails.config,
              placeholders: updatedSetting
                ? updatedSetting
                : prevTemplateDetails.config.placeholders,
            },
          };
        });
        setDeleteOrSubmit(null);
        setOpenChangeEmailTemplatePopup(false);
      }
    } else if (templateDetails && templateReducer.add_template) {
      //Checks if the template is of type scheduled mail and the flow is attached to an active case
      if (
        templateDetails.type === emailConstants.TEMPLATE_TYPE_SCHEDULED &&
        currentEmaiFlow.cases?.some(
          (c) => c.state === caseConstants.CASE_STATE_ACTIVE,
        ) &&
        !(typeof updateScheduledEmails === "boolean")
      ) {
        setDeleteOrSubmit(1);
        setOpenChangeEmailTemplatePopup(true);
      } else {
        dispatch(
          templateActions.addTemplate(
            emailFlowReducer.selected_email,
            updateScheduledEmails,
            templateDetails,
          ),
        );
        setDeleteOrSubmit(null);
        setOpenChangeEmailTemplatePopup(false);
      }
    }
    setBtnPressed(false);
  };

  const dispatchTemplateUpdate = (updateScheduledEmails) => {
    dispatch(
      templateActions.updateTemplate(
        emailFlowReducer.selected_email,
        selectedTemplate.id,
        updateScheduledEmails,
        templateDetails,
      ),
    );
  };

  useEffect(() => {
    if (
      templateReducer.status.TEMPLATE_POST === "success" ||
      templateReducer.status.TEMPLATE_PUT === "success"
    ) {
      dispatch(emailActions.getEmail());
      dispatch(templateActions.getTemplates(emailFlowReducer.selected_email));
      if (templateReducer.status.TEMPLATE_POST === "success")
        dispatch(templateActions.selectTemplate(templateDetails));
      dispatch(templateActions.clearStatusMessage("TEMPLATE_POST"));
      dispatch(templateActions.clearStatusMessage("TEMPLATE_PUT"));
    }
    // eslint-disable-next-line
  }, [
    dispatch,
    templateReducer.status.TEMPLATE_POST,
    templateReducer.status.TEMPLATE_PUT,
    emailFlowReducer.selected_email,
  ]);

  useEffect(() => {
    if (
      templateReducer.flow_templates &&
      templateReducer.flow_templates[emailFlowReducer.selected_email]?.length >
        0
    ) {
      let template = templateReducer.flow_templates[
        emailFlowReducer.selected_email
      ].find((x) => selectedTemplate && x && x.name === selectedTemplate.name);
      if (template && !selectedTemplate.id) {
        dispatch(templateActions.selectTemplate(template));
      }
    }
  }, [
    dispatch,
    templateReducer.flow_templates,
    selectedTemplate,
    emailFlowReducer.selected_email,
  ]);

  // display template POST success & error
  useEffect(() => {
    if (templateReducer.status.TEMPLATE_POST === "success") {
      showSnackbarSuccess("Success!");
      if (templateReducer.affectedCases.length > 0) setOpenInfoPopup(true);
      dispatch(templateActions.clearStatusMessage("TEMPLATE_POST"));
    } else if (catchError(templateReducer.status.TEMPLATE_POST)) {
      showSnackbarError(templateReducer.status.TEMPLATE_POST);
      dispatch(templateActions.clearStatusMessage("TEMPLATE_POST"));
    } else return;
  }, [
    dispatch,
    showSnackbarError,
    showSnackbarSuccess,
    templateReducer.affectedCases,
    templateReducer.status,
  ]);

  // display template PUT success & error
  useEffect(() => {
    if (templateReducer.status.TEMPLATE_PUT === "success") {
      showSnackbarSuccess("Success!");
      if (templateReducer.affectedCases.length > 0) setOpenInfoPopup(true);

      dispatch(templateActions.clearStatusMessage("TEMPLATE_PUT"));
    } else if (catchError(templateReducer.status.TEMPLATE_PUT)) {
      showSnackbarError(templateReducer.status.TEMPLATE_PUT);
      dispatch(templateActions.clearStatusMessage("TEMPLATE_PUT"));
    } else return;
  }, [
    dispatch,
    showSnackbarError,
    showSnackbarSuccess,
    templateReducer.affectedCases,
    templateReducer.status,
  ]);

  // display template DELETE success & error
  useEffect(() => {
    if (templateReducer.status.TEMPLATE_DELETE === "success") {
      showSnackbarSuccess("deletion successful!");
      dispatch(templateActions.clearStatusMessage("TEMPLATE_DELETE"));
      dispatch(templateActions.selectTemplate({}));
      history.push(`/templates/email_flows/${selectedTemplate.emailFlowId}`);
    } else if (catchError(templateReducer.status.TEMPLATE_DELETE)) {
      showSnackbarError(templateReducer.status.TEMPLATE_DELETE);
      dispatch(templateActions.clearStatusMessage("TEMPLATE_DELETE"));
    } else return;
    // eslint-disable-next-line
  }, [
    dispatch,
    history,
    selectedTemplate,
    showSnackbarError,
    showSnackbarSuccess,
    templateReducer.status,
  ]);

  const handleAddPlaceholder = (placeholder, subjectPlaceholder) => {
    if (subjectClicked && subjectPlaceholder) {
      setDisabledPlaceholders(false);
      if (curPosition || curPosition === 0) {
        let textBeforeCursorPosition = templateDetails.subject.substring(
          0,
          curPosition,
        );
        let textAfterCursorPosition = templateDetails.subject.substring(
          curPosition,
          templateDetails.subject.length,
        );
        setTemplateDetails({
          ...templateDetails,
          subject: `${textBeforeCursorPosition}{{${placeholder}}}${textAfterCursorPosition}`,
        });
      } else {
        setTemplateDetails({
          ...templateDetails,
          subject: `${templateDetails.subject}{{${placeholder}}}`,
        });
      }

      document.getElementById("subject_input").focus();
    } else if (contentClicked) {
      if (placeholder === "image_uses") {
        if (currentEmaiFlow.config?.image_uses) {
          setOldImageUseOptions(currentEmaiFlow.config?.image_uses);
        } else {
          setOldImageUseOptions(null);
        }
        setOpenImageUsesPopup(true);
        return;
      }
      if (placeholder === "salutation") {
        if (currentEmaiFlow.config?.salutation) {
          setOldSalutationsOptions(currentEmaiFlow.config?.salutation);
        } else {
          setOldSalutationsOptions(null);
        }
        setOpenSalutationsPopup(true);
        return;
      }
      if (placeholder === "settlement_portal") {
        if (currentEmaiFlow.config?.settlement_portal) {
          setOldSettlementPortalOptions(
            currentEmaiFlow.config?.settlement_portal,
          );
        } else {
          setOldSettlementPortalOptions(null);
        }
        setOpenSettlementPortalPopup(true);
        return;
      }
      setDisabledPlaceholders(false);
      addPlaceholderToContent("{{" + placeholder + "}}");
    } else return;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      setDisabledPlaceholders(true);
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside, dispatch]);

  const addUsesPlaceholder = (searchWord, options) => {
    let placeholder = "";
    if (!wordClicked) {
      const indexOfSearchWord = templateDetails.content
        ?.toLowerCase()
        .indexOf(`{{${searchWord.toLowerCase()}}}`);
      placeholder = `{{${searchWord}}}`;
      if (indexOfSearchWord !== -1) {
        if (
          templateDetails.content?.toLowerCase().indexOf(searchWord + "_") !==
          -1
        ) {
          let occurenceNumber = 2;
          while (
            templateDetails.content
              ?.toLowerCase()
              .indexOf(`${searchWord}_${occurenceNumber}`) !== -1
          ) {
            occurenceNumber++;
          }
          placeholder = `{{${searchWord}_${occurenceNumber}}}`;
        } else {
          placeholder = "{{" + searchWord + "_2}}";
        }
      }
      addPlaceholderToContent(placeholder);
    } else if (wordClicked) {
      placeholder = wordClicked;
      setWordClicked(null);
    }
    const configCopy = templateDetails.config;
    configCopy.placeholders = {
      ...templateDetails.config.placeholders,
      [placeholder.slice(2, placeholder.length - 2)]: options,
    };
    setOldImageUseOptions(null);
    setOldSalutationsOptions(null);
    setOldSettlementPortalOptions(null);
  };

  const addPlaceholderToContent = (placeholder) => {
    if (curPosition || curPosition === 0) {
      let textBeforeCursorPosition = templateDetails.content.substring(
        0,
        curPosition,
      );
      let textAfterCursorPosition = templateDetails.content.substring(
        curPosition,
        templateDetails.content.length,
      );
      setTemplateDetails({
        ...templateDetails,
        content: `${textBeforeCursorPosition}${placeholder}${textAfterCursorPosition}`,
      });
    } else {
      setTemplateDetails({
        ...templateDetails,
        content: `${templateDetails.content}${placeholder}`,
      });
    }
  };

  // return the word under cursor postion or undefined if no word was found
  const getSelectedWord = (text, position) => {
    if (!text || text.trim().length === 0) return undefined;
    var word = "";
    if (text[position]) {
      // search forward
      for (var i = position; i < 5000; i++) {
        let char = text[i];
        if ((char && char.trim().length === 0) || char === "{") {
          break;
        } else if (char && char.trim().length !== 0) {
          word += char;
          if (char === "}" && text[i + 1] === "}") {
            word += "}";
            break;
          }
        } else break;
      }

      // search backward
      for (var j = position - 1; j < 5000; j--) {
        let char = text[j];
        if ((char && char.trim().length === 0) || char === "}") {
          break;
        } else if (char && char.trim().length !== 0) {
          word = char + word;
          if (char === "{" && text[j - 1] === "{") {
            word = "{" + word;
            break;
          }
        } else break;
      }
    }

    return word === "" ? undefined : word;
  };

  // handle click event in textarea
  const handleSelectedWordClicked = (e) => {
    var text = e.target.value;
    var cursorposition = e.target.selectionStart;

    var selectedWord = getSelectedWord(text, cursorposition);
    if (selectedWord?.includes("image_uses") && selectedWord?.length < 25) {
      setOldImageUseOptions(
        templateDetails.config?.placeholders?.[
          selectedWord.slice(2, selectedWord.length - 2)
        ],
      );
      setDisabledPlaceholders(true);
      setOpenImageUsesPopup(true);
      setWordClicked(selectedWord);
    } else if (
      selectedWord?.includes("salutation") &&
      selectedWord?.length < 25
    ) {
      setOldSalutationsOptions(
        templateDetails.config?.placeholders?.[
          selectedWord.slice(2, selectedWord.length - 2)
        ],
      );
      setOpenSalutationsPopup(true);
      setWordClicked(selectedWord);
    } else if (
      selectedWord?.includes("settlement_portal") &&
      selectedWord?.length < 25
    ) {
      setOldSettlementPortalOptions(
        templateDetails.config?.placeholders?.[
          selectedWord.slice(2, selectedWord.length - 2)
        ],
      );

      setOpenSettlementPortalPopup(true);
      setWordClicked(selectedWord);
    }
  };

  const handleClosePlaceholderPopup = () => {
    setOpenSettlementPortalPopup(false);
    setOpenSalutationsPopup(false);
    setOpenImageUsesPopup(false);
    setWordClicked(null);
  };

  return (
    <div className={styles.root}>
      <AppSnackbar {...snackbarProps} />

      {templateReducer.addTemplate || selectedTemplate ? (
        <>
          <div className={styles.template_container}>
            <div ref={temlateContainerRef} className={styles.template_col}>
              <div className={styles.template_setup}>
                <div className={styles.template_text_container}>
                  <TextfieldInput
                    label="Template Name"
                    placeholder="Template Name"
                    onChange={handleInputChange}
                    name="name"
                    value={templateDetails.name}
                    required
                    inputProps={{
                      tabIndex: 1,
                    }}
                    error={btnPressed && isNull(templateDetails.name)}
                  />
                </div>

                {templateDetails.type ===
                  emailConstants.TEMPLATE_TYPE_TRIGGERED &&
                templateDetails.trigger_event &&
                templateDetails.trigger_event ===
                  emailConstants.TRIGGER_EVENT_DISOUNT_END ? (
                  <div className={styles.template_days_container}>
                    <p>To be sent 1 day before discount ends</p>
                  </div>
                ) : (
                  <div
                    className={`${styles.template_days_container} ${
                      templateDetails.type ===
                      emailConstants.TEMPLATE_TYPE_SCHEDULED
                        ? ""
                        : styles.hidden
                    }`}
                  >
                    <TextfieldInput
                      id="outlined-number"
                      label="Days after intial Email"
                      placeholder="Days after intial Email"
                      type="number"
                      inputProps={{
                        tabIndex: 2,
                      }}
                      name="schedule_num_days"
                      onChange={handleInputChange}
                      value={templateDetails.schedule_num_days}
                      required
                      error={
                        btnPressed && isNull(templateDetails.schedule_num_days)
                      }
                    />
                  </div>
                )}

                <div className={styles.template_days_container}>
                  <TextfieldInput
                    className={styles.input_small}
                    select
                    label="Localization"
                    id="localization"
                    name="localization"
                    value={templateDetails.localization}
                    onChange={handleInputChange}
                    inputProps={{
                      tabIndex: 3,
                    }}
                    required
                    error={btnPressed && isNull(templateDetails.localization)}
                  >
                    {IsoRegionLanguageList.map((language) => (
                      <MenuItem key={language.isoName} value={language.isoName}>
                        {language.displayName}
                      </MenuItem>
                    ))}
                  </TextfieldInput>
                </div>
              </div>
              {templateDetails.type === emailConstants.TEMPLATE_TYPE_LETTER && (
                <div className={styles.letter_setup}>
                  <div className={styles.template_text_container}>
                    <TextfieldInput
                      label="Label for Case ID"
                      placeholder="Case ID"
                      onChange={handleInputChange}
                      name="case_id_label"
                      value={
                        templateDetails.config.letter_header?.case_id_label ||
                        ""
                      }
                      required
                      inputProps={{
                        tabIndex: 4,
                      }}
                      error={
                        btnPressed &&
                        isNull(
                          templateDetails.config.letter_header?.case_id_label,
                        )
                      }
                    />
                    <TextfieldInput
                      label="Label for Case PIN"
                      placeholder="Case PIN"
                      onChange={handleInputChange}
                      name="case_pin_label"
                      value={
                        templateDetails.config.letter_header?.case_pin_label ||
                        ""
                      }
                      required
                      inputProps={{
                        tabIndex: 5,
                      }}
                      error={
                        btnPressed &&
                        isNull(
                          templateDetails.config.letter_header?.case_pin_label,
                        )
                      }
                    />
                  </div>
                  <Tooltip
                    placement="top"
                    title={
                      <div
                        className={styles.tooltip_title}
                        dangerouslySetInnerHTML={{
                          __html:
                            "If you do not define a sender address here, the business address from your account details will be used.",
                        }}
                      ></div>
                    }
                  >
                    <div className={styles.template_text_container}>
                      <TextfieldInput
                        label={
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {" "}
                            Sender Address{" "}
                            <IconButton size="small" style={{ marginLeft: 5 }}>
                              <InfoOutlined fontSize="small" />
                            </IconButton>
                          </div>
                        }
                        placeholder="Sender Address"
                        onChange={handleInputChange}
                        name="sender_address"
                        multiline
                        rows={5}
                        value={
                          templateDetails.config.letter_header
                            ?.sender_address || ""
                        }
                        inputProps={{
                          tabIndex: 6,
                        }}
                        sx={{
                          "& textarea": {
                            resize: "none",
                          },
                        }}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
              <TextfieldInput
                id="subject_input"
                placeholder="Subject"
                label="Subject"
                onChange={handleInputChange}
                name="subject"
                value={templateDetails.subject}
                required
                inputProps={{
                  tabIndex: 7,
                  style: { width: "100%" },
                }}
                sx={{ input: { width: "100%" } }}
                error={btnPressed && isNull(templateDetails.subject)}
                onClick={(e) => handleSubjectPlaceholder(e)}
              />

              {/*<RichTextEditor
                key={selectedTemplate.id}
                reference={editor}
                defaultValue={content}
                setContentCallback={setContent}
                onClickCallback={handleSaveCursorPosition}
                showAttachmentButton={false}
              />*/}
              <TextfieldInput
                // size="small"
                placeholder="Enter Text"
                label="Enter Text"
                multiline
                inputProps={{
                  tabIndex: 8,
                  className: "text-highlight-target",
                }}
                rows={25}
                onChange={handleInputChange}
                name="content"
                value={templateDetails.content}
                required
                error={btnPressed && isNull(templateDetails.content)}
                onClick={(e) => {
                  handleSaveCursorPosition(e);
                  handleSelectedWordClicked(e);
                }}
              />
            </div>
            <div>
              <div className={styles.template_action_container}>
                <Button
                  tabIndex={9}
                  className={styles.confirm_btn}
                  onClick={handleSubmitTemplateDetails}
                >
                  Save
                </Button>
                <Button
                  className={` ${styles.btn_cancel} btn_cancel ${
                    templateReducer.add_template ? "btn_disabled" : ""
                  } `}
                  onClick={handleDeleteTemplate}
                  tabIndex={10}
                  disabled={templateReducer.add_template}
                >
                  Delete
                </Button>
              </div>
              <div className={styles.placeholder_col}>
                <h1 className={styles.placeholder_group}>Placeholders</h1>
                <div
                  className={styles.placeholder_info_container}
                  ref={measuredRef}
                  id="placeholder_container_id"
                >
                  <Scrollbar
                    options={{ suppressScrollX: true }}
                    className={styles.placeholder_scrollbar}
                    maxHeight="calc(100vh - 419px)"
                  >
                    <p className={styles.placeholder_group}>
                      Website owner details
                    </p>
                    {templateReducer.placeholders &&
                      templateReducer.placeholders.placeholders &&
                      templateReducer.placeholders.placeholders.map(
                        (placeholder) => {
                          if (placeholder.category === "opponent details") {
                            return (
                              <div
                                className={
                                  styles.placeholder_item +
                                  " " +
                                  ((!placeholder.subject_placeholder &&
                                    subjectClicked) ||
                                  disabledPlaceholders
                                    ? styles.placeholder_disabled
                                    : styles.placeholder_enabled)
                                }
                                key={placeholder.name}
                              >
                                <Tooltip
                                  title={
                                    <div
                                      className={styles.tooltip_title}
                                      dangerouslySetInnerHTML={{
                                        __html: placeholder.description,
                                      }}
                                    ></div>
                                  }
                                >
                                  <p
                                    onClick={(e) =>
                                      handleAddPlaceholder(
                                        placeholder.name,
                                        placeholder.subject_placeholder,
                                      )
                                    }
                                  >
                                    {placeholder.name}
                                  </p>
                                </Tooltip>
                              </div>
                            );
                          } else return null;
                        },
                      )}
                    <p className={styles.placeholder_group}>
                      License offer details
                    </p>
                    {templateReducer.placeholders &&
                      templateReducer.placeholders.placeholders &&
                      templateReducer.placeholders.placeholders.map(
                        (placeholder, i) => {
                          if (placeholder.category === "infringement details") {
                            return (
                              <div
                                className={
                                  styles.placeholder_item +
                                  " " +
                                  ((!placeholder.subject_placeholder &&
                                    subjectClicked) ||
                                  disabledPlaceholders
                                    ? styles.placeholder_disabled
                                    : styles.placeholder_enabled)
                                }
                                key={placeholder.name}
                              >
                                <Tooltip
                                  title={
                                    <div
                                      className={styles.tooltip_title}
                                      dangerouslySetInnerHTML={{
                                        __html: placeholder.description,
                                      }}
                                    ></div>
                                  }
                                >
                                  <p
                                    onClick={(e) =>
                                      handleAddPlaceholder(
                                        placeholder.name,
                                        placeholder.subject_placeholder,
                                      )
                                    }
                                  >
                                    {placeholder.name}
                                  </p>
                                </Tooltip>
                              </div>
                            );
                          } else return null;
                        },
                      )}
                    <p className={styles.placeholder_group}>
                      case access details{" "}
                    </p>
                    {templateReducer.placeholders &&
                      templateReducer.placeholders.placeholders &&
                      templateReducer.placeholders.placeholders.map(
                        (placeholder, index) => {
                          if (placeholder.category === "case access details") {
                            return (
                              <div
                                className={
                                  styles.placeholder_item +
                                  " " +
                                  ((!placeholder.subject_placeholder &&
                                    subjectClicked) ||
                                  disabledPlaceholders
                                    ? styles.placeholder_disabled
                                    : styles.placeholder_enabled)
                                }
                                key={placeholder.name || index}
                              >
                                <Tooltip
                                  title={
                                    <div
                                      className={styles.tooltip_title}
                                      dangerouslySetInnerHTML={{
                                        __html: placeholder.description,
                                      }}
                                    ></div>
                                  }
                                >
                                  <p
                                    onClick={(e) =>
                                      handleAddPlaceholder(
                                        placeholder.name,
                                        placeholder.subject_placeholder,
                                      )
                                    }
                                  >
                                    {placeholder.name}
                                  </p>
                                </Tooltip>
                              </div>
                            );
                          } else return null;
                        },
                      )}
                  </Scrollbar>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.template_no_data}>No Template Selected</div>
      )}
      <AreYouSurePopup
        open={openAreYouSurePopup}
        close={() => {
          setDeleteOrSubmit(null);
          setOpenAreYouSurePopup(false);
        }}
        onClick={deleteTemplate}
      >
        Are you sure you want to delete this template?
      </AreYouSurePopup>

      <ChangeEmailTemplatePopup
        open={openChangeEmailTemplatePopup}
        close={() => {
          setDeleteOrSubmit(null);
          setOpenChangeEmailTemplatePopup(false);
        }}
        onYesClick={() => {
          deleteOrSubmit === 0
            ? deleteTemplate(true)
            : handleSubmitTemplateDetails(true);
        }}
        onNoClick={() => {
          deleteOrSubmit === 0
            ? deleteTemplate(false)
            : handleSubmitTemplateDetails(false);
        }}
      >
        <h3>
          Do you want to apply these changes on active cases using this flow?
        </h3>
        <p>
          Changes made to scheduled days may lead to needed manual intervention
          on some cases
        </p>
      </ChangeEmailTemplatePopup>
      <InfoPopup
        title="Affected cases"
        open={openInfoPopup}
        close={() => setOpenInfoPopup(false)}
      >
        <p>
          {templateReducer.affectedCases?.length} case(s) affected.
          {templateReducer.affectedCases?.some(
            (affectedCase) =>
              affectedCase.status === caseConstants.CASE_ACTIVITY_STATE_FAILED,
          ) && (
            <>
              <br />
              These cases failed and need manual interaction:
              <ol>
                {templateReducer.affectedCases
                  .filter(
                    (affectedCase) =>
                      affectedCase.status ===
                      caseConstants.CASE_ACTIVITY_STATE_FAILED,
                  )
                  .map((affectedCase) => (
                    <li key={affectedCase.case_id}>{affectedCase.case_id}</li>
                  ))}{" "}
              </ol>
            </>
          )}
        </p>
      </InfoPopup>
      <SalutationsPlaceholderPopup
        open={openSalutationsPopup}
        close={handleClosePlaceholderPopup}
        onAdd={addUsesPlaceholder}
        salutation={oldSalutationsOptions}
        wordClicked={wordClicked}
      />
      <ImageUsesPlaceholderPopup
        open={openImageUsesPopup}
        close={handleClosePlaceholderPopup}
        onAdd={addUsesPlaceholder}
        oldImageUseOptions={oldImageUseOptions}
        wordClicked={wordClicked}
      />
      <SettlementPortalLinkPopup
        open={openSettlementPortalPopup}
        close={handleClosePlaceholderPopup}
        onAdd={addUsesPlaceholder}
        oldSettlementPortalOptions={oldSettlementPortalOptions}
        wordClicked={wordClicked}
      />
    </div>
  );
}

export default EmailTemplate;
